export default __webpack_public_path__ + "static/RPALPHASTIK-ea07017699528b90eccef23070d2a305.jpg";